import React from 'react';
import { ONBOARDING_TYPE } from '../../utils/Constant';
import OnboardingPage from './OnboardingPage';
import { KYC_VERIFICATION_HEADER } from './OnboardingPageHelper';

const KYCVerificationPage: React.FunctionComponent = () => {
  return (
    <OnboardingPage
      onboardingType={ONBOARDING_TYPE.KYC_VERIFICATION}
      columnsHeder={KYC_VERIFICATION_HEADER}
      title="KYC Approval"
    />
  );
};
export default KYCVerificationPage;
